import { useEffect, useState } from "react";
import { API } from "aws-amplify";
import DynamicBreadcrumbs from "../../elements/v2/DynamicBreadcrumbs/DynamicBreadcrumbs";
import { getQuicksightEmbedUrl } from "../../graphql/queries";
import { useLocation } from "react-router-dom";
import { BreadcrumbContainer } from "./DashboarsPage.styled"
const QuickSightEmbedding = require("amazon-quicksight-embedding-sdk");


const DashboardsPage = () => {

    const [embedURL, setEmbedURL] = useState("")

    const fetchEmbedUrl = async () => {
        try {
            const response = await API.graphql({
                query: getQuicksightEmbedUrl,
                variables: {
                    input: {
                        "event_type": "GET_EMBED_URL",
                        "dashboard_id": "d32b5dac-aa0e-4e45-8d86-43c2fd2b5f29",
                        "user_arn": "arn:aws:quicksight:us-east-1:943437388571:user/default/edgardo@dealerlakes.com",
                        "initial_topic_id": "TP3dllTh448wMOnYUKMfvtGRPPgyrqrK",
                        "session_lifetime_in_minutes": 60
                    },
                },
                authMode: 'AMAZON_COGNITO_USER_POOLS'
            });
            const data = JSON.parse(response.data?.getQuicksightEmbedUrl?.body);
            setEmbedURL(data["dashboard_url"])
            
        } catch (error) {
            console.error("Error fetching:", error);
        }
    };

    const embedQSearchBar = async() => {    
        const {
            createEmbeddingContext,
        } = QuickSightEmbedding;

        const embeddingContext = await createEmbeddingContext();

        const frameOptions = {
            url: embedURL,
            container: '#experience-container',
            height: "800px",
            width: "100%",
        };

        const embeddedDashboardExperience = await embeddingContext.embedDashboard(frameOptions, {});
    };

    useEffect(() => {
        fetchEmbedUrl()
    }, [])

    useEffect(() => {
        if(embedURL){
            embedQSearchBar()
        }
    }, [embedURL])

    const location = useLocation();

    const breadcrumbItems = [
        { label: "Ask Questions", href: "/metrics/*" }
    ];

    return(
        <>  
            <BreadcrumbContainer>
                <DynamicBreadcrumbs items={breadcrumbItems} currentPath={location.pathname} />
            </BreadcrumbContainer>
           <div id="experience-container"></div>
        </>
    )
}

export default DashboardsPage